export default {
  CLEAR_TEAM_LIST: 'CLEAR_TEAM_LIST',
  FETCH_TEAM_LIST: 'FETCH_TEAM_LIST',
  FETCH_TEAM_LIST_SUCCESS: 'FETCH_TEAM_LIST_SUCCESS',
  FETCH_TEAM_LIST_ERROR: 'FETCH_TEAM_LIST_ERROR',
  
  INVITE_NEW_USER: 'INVITE_NEW_USER',
  INVITE_NEW_USER_SUCCESS: 'INVITE_NEW_USER_SUCCESS',
  INVITE_NEW_USER_ERROR: 'INVITE_NEW_USER_ERROR',
  INVITE_NEW_USER_RESET_STATE: 'INVITE_NEW_USER_RESET_STATE',

  CANCEL_USER_INVITE_ERROR: 'CANCEL_USER_INVITE_ERROR',
  CANCEL_USER_INVITE_SUCCESS: 'CANCEL_USER_INVITE_SUCCESS',
  CANCEL_USER_INVITE: 'CANCEL_USER_INVITE',
  CANCEL_USER_INVITE_RESET_STATE: 'CANCEL_USER_INVITE_RESET_STATE',

  REMOVE_USER: 'REMOVE_USER',
  REMOVE_USER_SUCCESS: 'REMOVE_USER_SUCCESS',
  REMOVE_USER_ERROR: 'REMOVE_USER_ERROR',
  REMOVE_USER_RESET_STATE: 'REMOVE_USER_RESET_STATE',
};
